import * as React from 'react';

import * as styles from './Month.css';

interface IMonthProps extends React.PropsWithChildren {
  header: React.ReactNode;
}

export const Month: React.FC<IMonthProps> = ({ children, header }) => {
  return (
    <div className={styles['month']}>
      <div className={styles['header']}>{header}</div>
      <div className={styles['dates']}>{children}</div>
    </div>
  );
};
